require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-tale-of-two-bootcamps-muay-thai-kickboxings-vs-code-201.json") })
        }
      }, "path---blog-a-tale-of-two-bootcamps-muay-thai-kickboxings-vs-code-201");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-tale-of-two-bootcamps-muay-thai-kickboxings-vs-code-201!./.cache/json/blog-a-tale-of-two-bootcamps-muay-thai-kickboxings-vs-code-201.json
// module id = 582
// module chunks = 231608221292675